import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { default as organizations } from '@assets/data/alias.json';
import { SnackbarService } from './snackbar.service';
import { Observable } from 'rxjs/internal/Observable';
import { of, throwError } from 'rxjs';
import { LoginResponse } from '@core/interfaces/auth.interface';
import { UserStateService } from './user-state.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tempPassword: string = '';

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    public router: Router,
    private snackbar: SnackbarService,
    private userStateService: UserStateService
  ) {}

  private urlOrds = signal<string>(environment.baseUrl);

  public login(
    username: string,
    password: string,
  ): Observable<LoginResponse> {
    this.tempPassword = password; 

    if (this.urlOrds()) {
      return this.http
        .post<LoginResponse>(this.urlOrds() + 'usuarios/login', { username, password })
        .pipe(
          map((user) => {
            if (user && user.token) {
              this.setSessionStorage(user);
              this.userStateService.updateUserInfo({
                usuario: user.dusuario,
              });
            }
            return user;
          })
        );
    } else {
      this.snackbar.warning('No se pudo establecer la URL del servidor', 4000);
      return throwError(() => new Error('No se pudo establecer la URL del servidor'));
    }
  }

  private setSessionStorage(user: any) {
    let token = {
      token: user.token,
    };
    const currentUser = JSON.stringify(token);
    sessionStorage.setItem('currentUser', currentUser);
    sessionStorage.setItem('usuario', user.usuario);
    sessionStorage.setItem('chgpass', user.chgpass);
    sessionStorage.setItem('estado', user.estado);
    sessionStorage.setItem('dusuario', user.dusuario);
    sessionStorage.setItem('idioma', user.idioma);
  }

  public forgotPassword(
    email: string,
    username: string
  ): Observable<{ usuario: number }> {
    if (this.urlOrds()) {
      return this.http.put<{ usuario: number }>(this.urlOrds() + 'usuarios/login/validamail', {
        email,
        username,
      });
    } else {
      this.snackbar.warning('Organización incorrecta', 4000);
      return throwError(() => new Error('Organización incorrecta'));
    }
  }

  public changePassword(iduserpcdr: number, newpass: string, codigo: string): Observable<any> {
    return this.http.put<void>(this.urlOrds() + 'usuarios/login/resetpass/' + iduserpcdr, {
      newpass,
      codigo,
    });
  }

  public firstLogin(usuario: number, newpass: string): Observable<any> {
    return this.http.put<void>(this.urlOrds() + 'usuarios/login/primerlogin', {
      usuario,
      newpass,
    });
  }

  public logout() {
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('baseUrl');
    sessionStorage.removeItem('chgpass');
    sessionStorage.removeItem('estado');
    sessionStorage.removeItem('dusuario');
    sessionStorage.removeItem('idioma');

    this.userStateService.clearUserState();

    this.router.navigate(['/login']);
  }

  public isAuthenticated(): boolean {
    return this.userStateService.isAuthenticated();
  }

  public needsPasswordChange(): boolean {
    return sessionStorage.getItem('chgpass') === 'S';
  }

}
